import { HStack, XButton, XText } from "IZOX/_X";
import { LocaleX } from "IZOX/STATIC";
import _ from "lodash";

/**
 * @typedef {import("./QTab").qtab} qtab
 * 
 * @typedef {Object} qtabluxparams
 * @property {String} tab
 * @property {qtab[]} tabs
 * @property {(tab) => void} setTab
 * @property {Number} height
 * @property {Boolean} shiftAlign
 * 
 * @param {qtabluxparams} param0 
 * @returns 
 */
function QTabLux({
  tab,
  tabs,
  setTab,
  shiftAlign = true,
  height = 30,
  renderer
}){

  return (
    <HStack position="relative" fullWidth height={height}>
      {_.map(tabs, (o, idx) => {
        let {_id, bgColor, color, icon, label} = o;
        let inTabIndex = _.findIndex(tabs, o => o._id === tab);
        let inTab = inTabIndex === idx;
        let zIndex = inTab ? 20 : 
          inTabIndex < idx ? 10 - idx :
          idx;
        let ttlTab = tabs.length;
        //TODO: beautifully
        let leftPosition = idx * (100/ttlTab) - (idx * 5) + "%";
        let tabW = ((100/ttlTab) + (ttlTab - 1) * 5) + "%";

        let _HAlign = shiftAlign ? (inTab ? "|" :
          inTabIndex < idx ? "]" : "[") : "|";

        return (
          <XButton onPress={() => setTab(_id)} p={0} key={idx}
            bgColor={bgColor}
            color={color}
            position="absolute"
            top={0} left={leftPosition} width={tabW} zIndex={zIndex}
            round={[25, 25, 0, 0]} fullHeight>
            {renderer?.() ?? 
              <HStack width="100%" spacing={10} pH={25}
                HAlign={_HAlign}>
                <XText bold fontSize={"1em"} color={color}
                  fontFamily="sans-serif" textTransform="none">
                  {LocaleX.Parse(label)}
                </XText>
                {icon}
              </HStack>}
          </XButton>
        );
      })}
    </HStack>
  );

}

export default QTabLux;